module.exports = __webpack_public_path__ + "img/chanchu.59ba9244.png";